function extractStringFromQueryKeyPart<TReturn extends string>(part: string | unknown | undefined): TReturn {
    return part ? ((part as string).split(":")[1] as TReturn) : undefined
}

function extractNumberFromQueryKeyPart(part: string | unknown | undefined): number {
    return part ? parseInt((part as string).split(":")[1], 10) : undefined
}

export { extractStringFromQueryKeyPart, extractNumberFromQueryKeyPart }
